import React from 'react';
import cx from 'classnames';
import styles from './styles.scss';

const Tags = ({ tags, theme }: { tags: ?Array<string>, theme: string }) => {
  if (!tags || !tags.length) {
    return null;
  }

  /* eslint-disable react/no-array-index-key */
  return (
    <section>
      {tags.map((tag, idx) => (
        <span key={idx} className={cx(styles.tag, styles[theme])}>
          {tag}
        </span>
      ))}
    </section>
  );
  /* eslint-enable react/no-array-index-key */
};

export default Tags;



// WEBPACK FOOTER //
// ./src/components/Above/Tags.js